import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ReportsCommonService } from 'src/app/services/reports-common.service';
import * as FileSaver from 'file-saver-es';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';
import { Router } from '@angular/router';
import moment from 'moment';
import { ReplaySubject, map, startWith } from 'rxjs';

@Component({
  selector: 'app-reports-order-info',
  templateUrl: './reports-order-info.component.html',
  styleUrls: ['./reports-order-info.component.scss'],
  standalone: false // NOSONAR
})
export class ReportsOrderInfoComponent implements OnInit {

  dropdownOptionOrderSupp: any;
  dropdownOptionOrderPlant: any;
  dropdownOptionOrderRoute: any;
  dropdownOptionOredrRegion: any;
  dropdownOptionOredrTP: any;
  dropdownOptionOrderSts: any;
  selectedOrderRegion: any[] = [];
  selectedOrderPlant: any[] = [];
  selectedOrderRoute: any[] = [];
  selectedOrderTP: any[] = [];
  selectedOrderSts: any[] = [];
  selectedOrderSupp: any[] = [];
  event: any;
  errorMessage: any;
  successMessage: any;
  isAccessible = true;
  nextDate: any;
  newDate: any;
  now = new Date();
  maxDate = moment(new Date()).format('YYYY-MM-DD');
  pastDate = new Date(this.now.getTime() - 86400000);
  test = new Date(this.pastDate.getFullYear() - 5, this.pastDate.getMonth(), this.pastDate.getDate());
  minDate = this.test.toISOString().split('T')[0];
  yesterday = this.pastDate.toISOString().split('T')[0];
  orderStsFilterCtrl: FormControl = new FormControl();
  filteredOrderSts: ReplaySubject<any[]> = new ReplaySubject(1);
  orderFilterCtrl: FormControl = new FormControl();
  filteredOrder: ReplaySubject<any[]> = new ReplaySubject(1);

  orderRegFilterCtrl: FormControl = new FormControl();
  filteredOrderReg: ReplaySubject<any[]> = new ReplaySubject(1);

  orderTpFilterCtrl: FormControl = new FormControl();
  filteredOrderTp: ReplaySubject<any[]> = new ReplaySubject(1);

  plantFilterCtrl: FormControl = new FormControl();
  filteredPlant: ReplaySubject<any[]> = new ReplaySubject(1);
  constructor(
    public formBuilder: FormBuilder,
    private readonly commonService: ReportsCommonService,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    public constants: Constants,
    private readonly aetStateService: AetStateService,
    private readonly router: Router) {
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.commonService.getCommonReportByUser(userInfo).subscribe(data => { // NOSONAR

      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (data) {
        this.event = data

        if (this.event.body.oreportSuppliers && this.event.body.oreportSuppliers.length > 0) {
          this.event.body.oreportSuppliers.sort((a, b) => {
            const valueA = a.supplierName?.toLowerCase() ?? '';
            const valueB = b.supplierName?.toLowerCase() ?? '';

            if (valueA < valueB) {
              return -1;
            }

            if (valueA > valueB) {
              return 1;
            }

            return 0;
          });
          this.dropdownOptionOrderSupp = [];
          //this.dropdownOptionOrderSupp.push({ label: 0, value: 'ALL' })
          this.event.body.oreportSuppliers.forEach((obj, _index) => {
            const supplierCode = this.asNonEmptyString(obj?.supplierCode);
            const supplierName = this.asNonEmptyString(obj?.supplierName);
            const option = this.createOption(supplierCode, supplierCode && supplierName ? `${supplierCode} - ${supplierName}` : null);
            if (option) {
              this.dropdownOptionOrderSupp.push(option);
            }
          });
          this.filteredOrder.next(this.dropdownOptionOrderSupp?.slice());

          this.selectedOrderSupp = this.dropdownOptionOrderSupp;
        }
        if (this.event.body.reportPlants && this.event.body.reportPlants.length > 0) {
          this.event.body.reportPlants.sort((a, b) => {
            const valueA = a.itemCode?.toLowerCase() ?? '';
            const valueB = b.itemCode?.toLowerCase() ?? '';

            if (valueA < valueB) {
              return -1;
            }

            if (valueA > valueB) {
              return 1;
            }

            return 0;
          });
          this.dropdownOptionOrderPlant = [];
          //this.dropdownOptionOrderPlant.push({ label: 0, value: 'ALL' })
          this.event.body.reportPlants.forEach((obj, _index) => {
            const option = this.createOption(obj?.itemCode, obj?.itemCode);
            if (option) {
              this.dropdownOptionOrderPlant.push(option);
            }
          });
          this.filteredPlant.next(this.dropdownOptionOrderPlant?.slice());

          this.selectedOrderPlant = this.dropdownOptionOrderPlant
        }
        if (this.event.body.oreportRoutes && this.event.body.oreportRoutes.length > 0) {
          this.event.body.oreportRoutes.sort((a, b) => {
            const valueA = a?.toLowerCase() ?? '';
            const valueB = b?.toLowerCase() ?? '';

            if (valueA < valueB) {
              return -1;
            }

            if (valueA > valueB) {
              return 1;
            }

            return 0;
          });


          this.dropdownOptionOrderRoute = [];
          //this.dropdownOptionOrderRoute.push({ label: 0, value: 'ALL' })
          this.event.body.oreportRoutes.forEach((obj, _index) => {
            const option = this.createOption(obj, obj);
            if (option) {
              this.dropdownOptionOrderRoute.push(option);
            }
          });
          this.selectedOrderRoute = this.dropdownOptionOrderRoute;
        }
        if (this.event.body.oreportRegions && this.event.body.oreportRegions.length > 0) {
          this.dropdownOptionOredrRegion = [];
          //this.dropdownOptionOredrRegion.push({ label: 0, value: 'ALL' })
          this.event.body.oreportRegions.forEach((obj, _index) => {
            const option = this.createOption(obj?.regionDesc, obj?.regionCode);
            if (option) {
              this.dropdownOptionOredrRegion.push(option);
            }
          });
          this.filteredOrderReg.next(this.dropdownOptionOredrRegion?.slice());

          this.selectedOrderRegion = this.dropdownOptionOredrRegion;

        }
        if (this.event.body.oreportVendors && this.event.body.oreportVendors.length > 0) {
          this.event.body.oreportVendors.sort((a, b) => {
            const valueA = a.shortName?.toLowerCase() ?? '';
            const valueB = b.shortName?.toLowerCase() ?? '';

            if (valueA < valueB) {
              return -1;
            }

            if (valueA > valueB) {
              return 1;
            }

            return 0;
          });

          this.dropdownOptionOredrTP = [];
          // this.dropdownOptionOredrTP.push({ label: 0, value: 'ALL' })
          this.event.body.oreportVendors.forEach((obj, _index) => {
            const option = this.createOption(obj?.vendorId, obj?.shortName);
            if (option) {
              this.dropdownOptionOredrTP.push(option);
            }
          });
          this.filteredOrderTp.next(this.dropdownOptionOredrTP?.slice());

          this.selectedOrderTP = this.dropdownOptionOredrTP;
        }
        if (this.event.body.oreportStatuses && this.event.body.oreportStatuses.length > 0) {
          this.dropdownOptionOrderSts = [];
          //this.dropdownOptionOrderSts.push({ label: 0, value: 'ALL' })
          this.event.body.oreportStatuses.forEach((obj, _index) => {
            const option = this.createOption(obj?.statusId, obj?.description);
            if (option) {
              this.dropdownOptionOrderSts.push(option);
            }
          });
          this.filteredOrderSts.next(this.dropdownOptionOrderSts?.slice());

          this.selectedOrderSts = this.dropdownOptionOrderSts;
        }

      }
    }, _err => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      this.errorMessage = this.constants.downloadError;
    })
  }

  form!: FormGroup;
  submitted: boolean = false;
  curDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');

  ngOnInit() {
    // this.checkRoles();
    this.form = this.formBuilder.group({
      supplier: [''],
      plant: [''],
      route: [''],
      region: [''],
      transport_Provider: [''],
      status: [''],
      start_Date: ['', [Validators.required]],
      end_Date: ['', [Validators.required]]
    })
    this.orderStsFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOrderSts) : this.dropdownOptionOrderSts?.slice())
      )
      .subscribe(filtered => {
        this.filteredOrderSts.next(filtered);
      });
    this.orderFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOrderSupp) : this.dropdownOptionOrderSupp?.slice())
      )
      .subscribe(filtered => {
        this.filteredOrder.next(filtered);
      });

    this.orderRegFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOredrRegion) : this.dropdownOptionOredrRegion?.slice())
      )
      .subscribe(filtered => {
        this.filteredOrderReg.next(filtered);
      });


    this.orderTpFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOredrTP) : this.dropdownOptionOredrTP?.slice())
      )
      .subscribe(filtered => {
        this.filteredOrderTp.next(filtered);
      });

    this.plantFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionOrderPlant) : this.dropdownOptionOrderPlant?.slice())
      )
      .subscribe(filtered => {
        this.filteredPlant.next(filtered);
      });
  }

  private asNonEmptyString(value: unknown): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    const normalized = String(value).trim();
    return normalized.length > 0 ? normalized : null;
  }

  private createOption(label: unknown, value: unknown): { label: string; value: string } | null {
    const normalizedLabel = this.asNonEmptyString(label);
    const normalizedValue = this.asNonEmptyString(value);

    if (!normalizedLabel || !normalizedValue) {
      return null;
    }

    return {
      label: normalizedLabel,
      value: normalizedValue,
    };
  }

  private filterOption(search: string, list: any): any[] {
    const filterValue = search.toLowerCase();
    return (list || []).filter(d => d?.label?.toLowerCase()?.includes(filterValue));
  }
  isAllSelected(option: any, list: any): boolean {
    return option?.length == list?.length; // NOSONAR
  }

  isIndeterminate(option: any, list: any): boolean {
    return option?.length > 0 &&
      list?.length > 0 &&
      option?.length < list?.length;
  }


  toggleSelectAll(event: any, optionKey: string, list: any[]): void {
    (this as any)[optionKey] = event.checked ? [...list] : [];
  }
  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON?.parse(roles);
    if (userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
      userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner)
      || userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) || userRoles.includes(this.constants.LIOS_UAC_AET_LP)
      || userRoles.includes(this.constants.LIOS_UAC_General_User))) {
      this.isAccessible = true;

    }
    else {
      this.router.navigate([`/home`]);
    }
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   // this.isAccessible = true;
    // } else {
    //   this.router.navigate([`/home`]);
    // }
  }
  submitForm() {
    this.successMessage = null;
    this.errorMessage = null;
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    const start = formatDate(this.form.value.start_Date, 'MM/dd/yyyy', 'en');
    const end = formatDate(this.form.value.end_Date, 'MM/dd/yyyy', 'en');
    const params = {
      supplier: this.selectedOrderSupp,
      plant: this.selectedOrderPlant,
      region: this.selectedOrderRegion,
      transport_Provider: this.selectedOrderTP,
      status: this.selectedOrderSts,
      startDate: start,
      endDate: end,
    };
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.commonService.downloadFile(userInfo, params).subscribe({
      next: (response) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        const filename = 'AET-Order-Information' + this.curDate;
        const data: Blob = new Blob([(<any>response).body], {
          type: 'application/vnd.ms-excel',
        });
        FileSaver.saveAs(data, filename);
      },
      error: () => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.downloadError;

      },
    });
  }
  onDateChangedStart(event: any) {
    const valueStart = event?.target?.value;

    if (!valueStart) {
      return;
    }

    const currentDate = new Date(valueStart);
    if (isNaN(currentDate.getTime())) {
      return;
    }

    this.pastDate = new Date(currentDate.getTime() - 86400000);
    this.test = new Date(this.pastDate.getFullYear() - 5, this.pastDate.getMonth(), this.pastDate.getDate());
    this.minDate = this.test.toISOString().split('T')[0];
    this.yesterday = this.pastDate.toISOString().split('T')[0];
  }

  onDateChangedEnd(event) {
    const valueEnd = event?.target?.value;

    if (!valueEnd) {
      return;
    }

    const currentDate = new Date(valueEnd);
    if (isNaN(currentDate.getTime())) {
      return;
    }

    this.nextDate = new Date(currentDate.getTime() + 86400000);
    this.newDate = this.nextDate.toISOString().split('T')[0];
  }
}
